// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MasterImport__masterImportHeader___iRTpD {
    display: flex;
    align-items: center;
    justify-content: space-between;

    height: 4rem;
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
    padding-left: 1.2rem;
}

.MasterImport__masterImportFooter___T4vam {
    display: flex;
    gap: 0.8rem;
    align-items: center;
    justify-content: flex-end;

    height: 4.8rem;
    padding: 0.8rem 1.2rem;
}

.MasterImport__masterImportSteps___vXO4g {
    display: initial;
    width: auto;
    height: 4.8rem;
    padding-left: 1.2rem;
}

.MasterImport__masterImport___pwoAx {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: space-between;

    width: 0;
}

@media screen and (width < 112rem) {
    .MasterImport__masterImportScroll___wrjI9 {
        overflow-y: auto;
        height: 100%;
    }
}

@media screen and (width >= 112rem) {
    .MasterImport__masterImportScroll___wrjI9 {
        overflow-y: hidden;
        height: 100%;
    }
}

.MasterImport__masterImportScroll___wrjI9,
.MasterImport__readyStepScroll___fwWEO {
    display: flex;
    flex-direction: column;
    padding-right: 1.2rem;
}

.MasterImport__readyStepScroll___fwWEO {
    overflow-y: auto;
    height: 100%;
}

/* stylelint-disable-next-line selector-class-pattern -- Класс Consta */
.MasterImport__masterImportSteps___vXO4g .StepsStep_size_m {
    font-size: var(--size-text-s);
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/MasterImport/MasterImport.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,yBAAyB;;IAEzB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,8BAA8B;;IAE9B,QAAQ;AACZ;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,YAAY;IAChB;AACJ;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA,uEAAuE;AACvE;IACI,6BAA6B;AACjC","sourcesContent":[".masterImportHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    height: 4rem;\n    padding-top: 0.8rem;\n    padding-bottom: 0.8rem;\n    padding-left: 1.2rem;\n}\n\n.masterImportFooter {\n    display: flex;\n    gap: 0.8rem;\n    align-items: center;\n    justify-content: flex-end;\n\n    height: 4.8rem;\n    padding: 0.8rem 1.2rem;\n}\n\n.masterImportSteps {\n    display: initial;\n    width: auto;\n    height: 4.8rem;\n    padding-left: 1.2rem;\n}\n\n.masterImport {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    justify-content: space-between;\n\n    width: 0;\n}\n\n@media screen and (width < 112rem) {\n    .masterImportScroll {\n        overflow-y: auto;\n        height: 100%;\n    }\n}\n\n@media screen and (width >= 112rem) {\n    .masterImportScroll {\n        overflow-y: hidden;\n        height: 100%;\n    }\n}\n\n.masterImportScroll,\n.readyStepScroll {\n    display: flex;\n    flex-direction: column;\n    padding-right: 1.2rem;\n}\n\n.readyStepScroll {\n    overflow-y: auto;\n    height: 100%;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- Класс Consta */\n.masterImportSteps :global(.StepsStep_size_m) {\n    font-size: var(--size-text-s);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"masterImportHeader": `MasterImport__masterImportHeader___iRTpD`,
	"masterImportFooter": `MasterImport__masterImportFooter___T4vam`,
	"masterImportSteps": `MasterImport__masterImportSteps___vXO4g`,
	"masterImport": `MasterImport__masterImport___pwoAx`,
	"masterImportScroll": `MasterImport__masterImportScroll___wrjI9`,
	"readyStepScroll": `MasterImport__readyStepScroll___fwWEO`
};
export default ___CSS_LOADER_EXPORT___;
